import { apiInstances } from '../../../../libs';

const { get } = apiInstances.userInstance;

export async function getClouderServices({ id_clouder }) {
  return get(`clouders/${id_clouder}/services`);
}
